import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useProjectStore } from '../../../../entities/projects/stores/project.store'
import { Project } from '../../../../entities/projects/types/project.types'
import { useUserStore } from '../../../../entities/user/stores/user.store'
import { PureButton } from '../../../ui/pure-button/pure-button'
import { PureSelect } from '../../../ui/pure-select/pure-select'

export const ProjectSelectModal = () => {
  const { t } = useTranslation()
  const userStore = useUserStore()
  const projectStore = useProjectStore()
  const [selectedProject, setSelectedProject] = useState<Project | null>(null)
  const [error, setError] = useState<string | undefined>(undefined)

  const options = projectStore.projects.map((project) => ({
    label: project.name,
    value: project.id,
  }))

  const handleProjectChange = (projectId: string) => {
    const project = projectStore.projects.find((project) => project.id === Number(projectId)) ?? null
    setSelectedProject(project)
  }

  const handleProjectSelect = () => {
    if (!selectedProject) {
      setError(t('projects.noProjectSelectedError'))

      return
    }

    setError(undefined)
    userStore.updateUser({ projectId: selectedProject.id })
    projectStore.setProject(selectedProject)
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      window.location.reload()
    }, 500)
  }

  if (options.length) {
    return (
      <div>
        <PureSelect
          error={error}
          onChange={handleProjectChange}
          options={options}
          placeholder={t('projects.selectProjectDescription')}
          value={selectedProject?.id}
        />
        <div className="w-100 d-flex justify-content-center mt-3">
          <PureButton
            onClick={handleProjectSelect}
            size="small"
            type="primary"
          >
            {t('common.choose')}
          </PureButton>
        </div>
      </div>
    )
  } else {
    return <div className="w-100 text-center">{t('projects.noAvailableProjects')}</div>
  }
}
